import React, { useEffect, useState } from "react";
import axios from "axios";


const Empleos = ({ id }) => {
  const [listCourses, setlistCourses] = useState([]);

  useEffect(() => {
    let config = {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        "Access-Control-Allow-Origin": "*",
      },
    };

    axios.get("company-course/list-courses/" + id, config).then((result) => {
      setlistCourses(result.data);
    });
  }, []);

  const pp = { width: "146px", height: "138px" };
  return (
    <div className="vacancy__description bordered-box vacantes perfil-empresa usuario">
      <div className="bordered-box__header">
        <div className="bordered-box__header-title">Programas y Cursos</div>
        <div className="col-6 d-flex justify-content-end select-class">
          <label for="staticEmail" className="col-sm-10 col-form-label">
            Ordenar por:
          </label>
          <select
            className="col-sm-2 form-select form-select-sm"
            aria-label="Default select example"
          >
            <option selected>Más reciente</option>
            <option value="1">Más antiguo</option>
          </select>
        </div>
      </div>
      <div className="courseList">
        <div className="mt-4 row">
          {listCourses.map((item, index) => (
            <div key={index} className="col-sm-12 col-md-4">
              <img
                src={item.fotoCurso}
                style={{ maxWidth: "250px" }}
              />
              <p className="name">{item.name}</p>
              <p className="place">
                Lugar: <span>{item.ubicacion}</span>
              </p>
            </div>
          ))}
        </div>
      </div>
      {listCourses.length > 9 && (
        <div className="row mt-5 mb-4">
          <div id="buttons" className="col-md-12 d-flex justify-content-center">
            <button type="button" className="btn btn-info">
              Explorar más Cursos
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Empleos;
